// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__mrnin","checkBox":"style_checkBox__nIBum","text":"style_text__Uhmr9"};